<template>
  <div id="main" class="mt-4">
    <div>
      <h1>NIH and the American Recovery and Reinvestment Act Stories</h1>
      <p>
        NIH's two-year infusion of American Recovery and Reinvestment Act (ARRA)
        funds will empower the nation's best scientists to discover new cures,
        advance technology, and solve some of our greatest health challenges.
        Explore the stories of the people and science behind this unprecedented
        effort.
      </p>
    </div>
    <div v-if="serviceFailure">
      <b-alert show variant="danger">{{ message }}</b-alert>

      <b-button variant="outline-primary" :href="`/recovery`"
        >Go To NIH Recovery Act Archive</b-button
      >
    </div>
    <div id="btable" class="overflow-auto" v-else>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="story-reports-table"
        align="right"
      ></b-pagination>

      <b-table
        striped
        tableClass="cat-table"
        responsive
        id="story-reports-table"
        :busy.sync="isBusy"
        :fields="fields"
        :items="storyReports"
        :per-page="perPage"
        :current-page="currentPage"
        :outlined="true"
      >
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(title)="data">
          <a :href="`?reportName=story&id=${data.item.id}`">
            {{ data.item.title }}
          </a>
        </template>

        <template v-slot:cell(ics)="data">
          {{ data.item.ics.join(", ") }}
        </template>

        <template v-slot:cell(storyTypes)="data">
          {{ data.item.storyTypes.join(", ") }}
        </template>

        <template v-slot:cell(contactPI)="data">
          {{ data.item.contactPI.join(", ") }}
        </template>

        <template v-slot:cell(rcdcTopics)="data">
          {{ data.item.rcdcTopics.join(", ") }}
        </template>
      </b-table>
    </div>

    <div>
      <p>
        The Research/Disease Category search filter refers to the NIH Research,
        Condition, and Disease Category of the research projects cited in each
        story. Because some of the research projects cited fall into multiple
        categories, the search results may include stories that are not directly
        relevant to the category chosen.
      </p>
    </div>
  </div>
</template>
<script>
import { data } from "@/shared";
import { SERVICE_UNAVAILABLE_ERROR_MSG } from "@/shared/config.js";
export default {
  name: "StoryReports",
  data() {
    return {
      isBusy: false,
      storyReports: [],
      serviceFailure: false,
      message: SERVICE_UNAVAILABLE_ERROR_MSG,
      rows: 0,
      fields: [
        {
          key: "title",
          label: "Story Title"
        },
        {
          key: "state",
          label: "State"
        },
        {
          key: "ics",
          label: "NIH IC"
        },
        {
          key: "institute",
          label: "Awardees' Institution"
        },
        {
          key: "storyTypes",
          label: "Type of Stories"
        },
        {
          key: "contactPI",
          label: "Contact PI"
        },
        {
          key: "rcdcTopics",
          label: "Research/Disease Category"
        }
      ],
      currentPage: 1,
      perPage: 10
    };
  },
  async created() {
    await this.getStoryReportData();
  },

  methods: {
    async getStoryReportData() {
      this.storyReports = [];

      this.isBusy = true;
      this.storyReports = await data.getStories();

      if (!this.storyReports.length) {
        this.serviceFailure = true;
      } else {
        this.rows = this.storyReports.length;
      }
      this.isBusy = false;
    }
  }
};
</script>
<style></style>
